<template>
    <div v-if="getActiveMenu === 1">
        <Home></Home>
    </div>
    <div v-else>
        <Coopmode></Coopmode>
    </div>
</template>

<script type="application/javascript">
import { mapGetters } from "vuex";
import Home from "./pages/Home.vue";
import Coopmode from "./pages/Coopmode.vue"

export default {  
  components: {
    Home,
    Coopmode
  },
  computed: {
    ...mapGetters(["getActiveMenu"]),
  },
};
</script>